import React, { useState, useEffect } from "react";
import LogoImage from '../Assets/images/logo_title.png'
import LogoTitle from '../Assets/images/plunes-logo-text.png'
import HeroImage from '../Assets/images/hero_image.png'
import { useHistory } from "react-router-dom"

const LandingPage = () => {

    const history = useHistory()

    const [active, setActive] = useState('1')
    const [appLink, setAppLink] = useState('https://play.google.com/store/apps/details?id=com.plunes&amp;hl=en_IN/')

    useEffect(()=>{
        if(getMobileOperatingSystem() === 'iOS') {
            setAppLink('https://apps.apple.com/us/app/plunes/id1463747553/')
        }
    }, [])

    const handleLogin = () => {
        history.push('/auth', {activeTab: '1'})
    }

    const handleRegister = () => {
        history.push('/auth', {activeTab: '2'})
    }

    const getMobileOperatingSystem = () => {
        try {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/windows phone/i.test(userAgent)) {
                return "Windows Phone";
            }
        
            if (/android/i.test(userAgent)) {
                return "Android";
            }
        
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }
        
            return "unknown";
        } catch (err) {

        }
    }

    return (
        <>
        <div className="landing-page-container">
            <div className="dot-pattern-1"></div>
            <div className="dot-pattern-2"></div>
            <nav className="nav-bar">
                <img src={LogoTitle} className="nav-logo" alt="logo"/>
                <ul className="nav-list">
                    <li className={`nav-item ${active==='1' ? 'active' : ''}`} onClick={()=>setActive('1')}>Home</li>
                    <li className={`nav-item ${active==='2' ? 'active' : ''}`} onClick={()=>{setActive('2'); handleLogin()}}>Log In</li>
                    <li className={`nav-item ${active==='3' ? 'active' : ''}`} onClick={()=>setActive('3')}><a href={appLink}>Download The App</a></li>
                </ul>
            </nav>
            <div className="landing-container">
                <div className="left-container">
                    <div className="heading">
                        <h1>Join Plunes Network</h1>
                        <p>We enable cashless inpatient services in <span>12,000+</span> network hospitals, across <span>1100</span> cities, in India. </p>
                    </div>
                    <div className="description">
                        <p>'<strong>AWC PLATFORM</strong>' is a cloud platform powered by robust technology and  can help your hospital to expand 
                            reach and attract more patients, especially those who are looking for a seamless and convenient health 
                            care experience. The hospital can directly raise cash/ cashless requests for any insurer and provide 
                            cashless to the patient as per the policy coverage</p>
                    </div>
                    {/* <div className="button" onClick={handleRegister}>
                        <span>Register</span>
                    </div> */}
                    <div className="button" onClick={handleLogin}>
                        <span>Login</span>
                    </div>
                </div>
                <div className="right-container">
                    <img src={HeroImage} className="hero-img" alt="hero"/>
                </div>
            </div>
        </div>
        </>
    )
}

export default LandingPage